<script lang="ts">
  import { Col, Container, Row } from "sveltestrap";
  import BookmarkTodo from "./BookmarkTodo.svelte";
  import Card from "../../Core/Card.svelte";
  import {ToDo } from "../../../utils/Constant/Constant";
  import TodoList from "./TodoList.svelte";
  import TodoListFooter from "./TodoListFooter.svelte";
  import { toasts, ToastContainer, FlatToast } from 'svelte-toasts';
  import TodoBody from "./TodoBody.svelte";
</script> 

<BookmarkTodo />
<ToastContainer {toasts} let:data>
  <FlatToast {data} />
  <!-- default slot as toast component -->
</ToastContainer>
<Container fluid={true}>
  <Row>
    <Col xl="12">
      <Card headerTitle={ToDo} cardBodyprops="pt-0 position-static">
        <div slot="contentbody">
          <div class="todo">
            <div class="todo-list-wrapper">
              <TodoList />
              <TodoBody />
              <TodoListFooter />
            </div>
          </div>
        </div>
      </Card>
    </Col>
  </Row>
</Container>
